import { OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Pipe({
  name: 'catch',
  pure: false,
  standalone: true
})
export class CatchPipe implements OnDestroy, PipeTransform {

  private _observableWithCatch: Observable<IWithCatch<any>> | null = null;

  private _observable: Observable<any> | null = null;


  transform<T>(obj: Observable<T>): Observable<IWithCatch<T>> | null;
  transform<T>(obj: null | undefined): null;
  transform<T>(obj: Observable<T> | null | undefined): Observable<IWithCatch<T>> | null | undefined;

  transform<T>(observable: Observable<T> | null | undefined): Observable<IWithCatch<T>> | null | undefined {
    // console.log('in transform')

    if (!this._observable) {

      if (observable) {
        this.applyCatch(observable);
      }

      return this._observableWithCatch;
    }

    if (observable !== this._observable) {
      this._dispose();
      return this.transform(observable);
    }

    return this._observableWithCatch;
  }

  ngOnDestroy(): void {
    this._dispose();
  }

  private applyCatch<T>(obs: Observable<T>) {
    // console.log('in apply catch')
    this._observable = obs;

    this._observableWithCatch = obs.pipe(
      map(_ => {
        // console.log(_);

        return { value: _ } as IWithCatch<T>;
      }),
      catchError(e => {

        // console.log(e);

        return of({
          error: e
        } as IWithCatch<T>);
      }));
  }

  private _dispose(): void {
    this._observable = null;
    this._observableWithCatch = null;
  }
}

export interface IWithCatch<T> {
  value?: T,
  error?: any
}
